import React from 'react';
import { translate } from 'react-i18next';
import { SERVICE_CHAIN } from '../../../../utils/utils';

class MaintenancePartListItem extends React.Component {
  render() {
    const { part, service, t } = this.props;
    const isChainView = service === SERVICE_CHAIN;

    return (
      <div style={styles.partContainer}>
        <div style={styles.upperSectionContainer}>
          <div style={styles.leftSection}>
            {isChainView && part.is_chain_part === true && (
              <span style={styles.chainBadge} title={t('chainPartTooltip')}>&#10003;</span>
            )}
            {isChainView && part.is_chain_part === false && (
              <span style={styles.otherBadge} title={t('otherPartTooltip')}>&#10007;</span>
            )}
            <p className='font-titillium-web-semi-bold' style={styles.infoLabel}>
              {part.name}
              {' '}
              {part.amount}
              {' '}
              {part.unit}
            </p>
          </div>
          <div style={styles.rightSection}>
            {isChainView && part.is_chain_part && part.type_code && (
              <p style={styles.typeCode}>{part.type_code}</p>
            )}
            {isChainView && part.total_price != null && (
              <p style={styles.priceText}>
                {Number(part.total_price).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                {' \u20AC'}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  partContainer: {
    borderBottom: '1px solid rgba(255, 255, 255, .4)',
    minHeight: 46,
  },
  upperSectionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 16,
    paddingBottom: 8,
    paddingTop: 8,
    paddingRight: 16,
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  infoLabel: {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 600,
  },
  infoValue: {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 200,
  },
  typeCode: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: 12,
  },
  priceText: {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 600,
    minWidth: 70,
    textAlign: 'right',
  },
  chainBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#4CAF50',
    color: '#FFF',
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 8,
    flexShrink: 0,
  },
  otherBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#F44336',
    color: '#FFF',
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 8,
    flexShrink: 0,
  },
};

export default translate('VehicleDetailsView')(MaintenancePartListItem);
